module.exports = __webpack_public_path__ + "mj_ios_qr.afb9721.png";